var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.036,205.578l-36.334,33.809l-33.716-68.005l17.446-39.108c4.416-7.84,11.621-7.855,16.037,0   L297.036,205.578z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F57F17",
    points: "260.702,239.386 124.924,365.697 226.986,171.381  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.776,153.901c6.491-6.239,13.202-4.111,14.912,4.729l35.342,205.375L269.873,434.22   c-4.1,2.264-14.957,3.246-14.957,3.246s-9.91-1.185-13.687-3.281L124.92,365.69L336.776,153.901z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.986,171.381L124.924,365.697l45.46-283.998c1.674-8.847,6.71-9.699,11.203-1.89L226.986,171.381z",
    fill: "#FFA000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter6);
export default __webpack_public_path__ + "static/media/meter6.eeb7077534c1550d2f0140fd2a649dc7.svg";
export { ForwardRef as ReactComponent };